import { Route, Routes } from 'react-router'
import Auth from '../modules/auth';

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path='*' element={<Auth />} />
    </Routes>
  )
}

export default AuthRoutes;